import { Route, Routes } from "react-router-dom";
import A7OPCVMClientPortfolios from "./A7OPCVMClientPortfolios/main";
import A7OPCVMCompositions from "./A7OPCVMCompositions/main";
import A7OPCVMIssuers from "./A7OPCVMIssuers/main";
import A7OPCVMIssuerTS from "./A7OPCVMIssuerTS/main";
import A7OPCVMStrategies from "./A7OPCVMStrategies/main";
import A7OPCVMTimeSerieFiles from "./A7OPCVMTimeSerieFiles/main";
import A7OPCVMUnderlyings from "./A7OPCVMUnderlyings/main";
import A7OPCVMUnderlyingTS from "./A7OPCVMUnderlyingTS/main";

import A7OPCVMDownloadCenter from "@/pages/a7/A7OPCVMDownloadCenter/main";

export default function A7OPCVMRoutes() {
  return (
    <Routes>
      <Route
        path="a7_opcvm_client_portfolios/*"
        element={<A7OPCVMClientPortfolios />}
      />
      <Route path="a7_opcvm_compositions/*" element={<A7OPCVMCompositions />} />
      <Route path="a7_opcvm_issuer_ts/*" element={<A7OPCVMIssuerTS />} />
      <Route path="a7_opcvm_issuers/*" element={<A7OPCVMIssuers />} />
      <Route path="a7_opcvm_strategies/*" element={<A7OPCVMStrategies />} />
      <Route
        path="a7_opcvm_time_serie_files/*"
        element={<A7OPCVMTimeSerieFiles />}
      />
      <Route path="a7_opcvm_underlyings/*" element={<A7OPCVMUnderlyings />} />
      <Route
        path="a7_opcvm_underlying_ts/*"
        element={<A7OPCVMUnderlyingTS />}
      />
      <Route
        path="a7_opcvm_download_center/*"
        element={<A7OPCVMDownloadCenter />}
      />
    </Routes>
  );
}
